<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ (data?.id?'title.update-record':'title.new-record') | translate}}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()">

  </button>
</div>

<div class="modal-body">
  <!-- Güncelleme  -->
  <div>
    <form #createForm="ngForm" class="needs-validation" novalidate>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-6">
              <!--Firmas -->
              <div class="col">
                <label class="custom-form-label" for="vendorType" vendorType>{{'billingSetting.vendorType' | translate}}</label>
                <select name="vendorType" [(ngModel)]="data.vendorType" (ngModelChange)="onVendorTypeChange()" class="form-control" required>
                  <option *ngFor="let option of cashRegisterVendorTypeEnumValues" [ngValue]="option">
                    {{ option}}
                  </option>
                </select>
              </div>
              <!-- Mağaza -->
              <div class="form-group">
                <label class="custom-form-label" for="storeId">{{'store.storeName' | translate}}</label>
                <select #storeId id="storeId" name="storeId" [(ngModel)]="data.storeId" class="form-control" required>
                  <option *ngFor="let option of stores" [ngValue]="option.id">
                    {{ option.name }}
                  </option>
                </select>
                <app-field-error-display [displayError]="storeId.invalid && storeId.touched" errorMsg="{{'message.error.cannot-be-blank' | translate}}">
                </app-field-error-display>
              </div>
              <!-- Ad-->
              <div class="form-group">
                <label class="custom-form-label" for="name">{{'common.name' | translate}}</label>
                <input #name="ngModel" type="text" class="form-control" name="name" [(ngModel)]="data.name" appUppercase required [class.is-invalid]="name.invalid && name.touched" ngbAutoFocus />
                <app-field-error-display [displayError]="name.invalid && name.touched" errorMsg="{{'message.error.cannot-be-blank' | translate}}">
                </app-field-error-display>
              </div>

              <!-- Bağlantı Tipi -->
              <!-- <div class="form-group">
            <label class="custom-form-label" for="connectionType">{{'common.connectionType' | translate}}</label>
            <select #connectionType="ngModel" name="connectionType" [(ngModel)]="data.connectionType" class="form-control" required>
              <option *ngFor="let option of cashRegisterConnectionTypeEnumValues" [ngValue]="option">
                {{ option}}
              </option>
            </select>
            <app-field-error-display [displayError]="connectionType.invalid && connectionType.touched" errorMsg="{{'message.error.cannot-be-blank' | translate}}">
            </app-field-error-display>
          </div> -->
              <!-- Kullanıcı Adı -->
              <div class="col"
                *ngIf="data.vendorType == cashRegisterVendorTypeEnum.OMNISOFT ||data.vendorType == cashRegisterVendorTypeEnum.NBASOFT || data.vendorType == cashRegisterVendorTypeEnum.CASPOS">
                <label class="custom-form-label" for="userName">{{'common.userName' | translate}}</label>
                <input #userName="ngModel" type="text" class="form-control" name="userName" [(ngModel)]="data.userName" required [class.is-invalid]="userName.invalid && userName.touched"
                  autocomplete="new-username" />
                <app-field-error-display [displayError]="userName.invalid && userName.touched" errorMsg="{{'message.error.cannot-be-blank' | translate}}">
                </app-field-error-display>
              </div>
              <!-- Şifre -->
              <div class="col"
                *ngIf="data.vendorType == cashRegisterVendorTypeEnum.OMNISOFT ||data.vendorType == cashRegisterVendorTypeEnum.NBASOFT || data.vendorType == cashRegisterVendorTypeEnum.CASPOS">
                <label class="custom-form-label" for="password">{{'common.password' | translate}}</label>
                <div class="input-group">
                  <input #password="ngModel" class="form-control" name="password" [(ngModel)]="data.password" [type]="fieldTextType ? 'text' : 'password'" required
                    [class.is-invalid]="password.invalid && password.touched" autocomplete="new-password" />
                  <app-field-error-display [displayError]="password.invalid && password.touched" errorMsg="{{'message.error.cannot-be-blank' | translate}}">
                  </app-field-error-display>
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i class="fa" [ngClass]="{'fas fa-eye-slash': !fieldTextType,'fas fa-eye': fieldTextType }" (click)="fieldTextType = !fieldTextType"></i>
                    </span>
                  </div>
                </div>
              </div>

              <!-- apiKey -->
              <div class="col" *ngIf="data.vendorType == cashRegisterVendorTypeEnum.ODEAL||
          data.vendorType == cashRegisterVendorTypeEnum.SMARTONE">
                <label class="custom-form-label" for="merchantKeyInput">{{'common.merchantKey' | translate}}</label>
                <input #merchantKeyInput="ngModel" name="merchantKeyInput" type="text" class="form-control" [(ngModel)]="data.merchantKey" required
                  [class.is-invalid]="merchantKeyInput.invalid && merchantKeyInput.touched" />
                <app-field-error-display [displayError]="merchantKeyInput.invalid && merchantKeyInput.touched" errorMsg="{{'message.error.cannot-be-blank' | translate}}">
                </app-field-error-display>
              </div>

              <!-- secretKey -->
              <div class="col" *ngIf="data.vendorType == cashRegisterVendorTypeEnum.ODEAL">
                <label class="custom-form-label" for="secretKeyInput">{{'common.secretKey' | translate}}</label>
                <input #secretKeyInput="ngModel" name="secretKeyInput" type="text" class="form-control" [(ngModel)]="data.secretKey" required
                  [class.is-invalid]="secretKeyInput.invalid && secretKeyInput.touched" />
                <app-field-error-display [displayError]="secretKeyInput.invalid && secretKeyInput.touched" errorMsg="{{'message.error.cannot-be-blank' | translate}}">
                </app-field-error-display>
              </div>

              <!-- Cihaz Kodu -->
              <div class="form-group" *ngIf="data.vendorType == cashRegisterVendorTypeEnum.ODEAL||
          data.vendorType == cashRegisterVendorTypeEnum.HUGIN||
          data.vendorType == cashRegisterVendorTypeEnum.INPOS||
          data.vendorType == cashRegisterVendorTypeEnum.PAVO||
          data.vendorType == cashRegisterVendorTypeEnum.BEKO">
                <label class="custom-form-label" for="deviceCode">{{'device.deviceCode' | translate}}</label>
                <input type="text" #deviceCode="ngModel" name="deviceCode" [(ngModel)]="data.deviceCode" required class="form-control" [class.is-invalid]="deviceCode.invalid && deviceCode.touched" />

                <app-field-error-display [displayError]="deviceCode.invalid && deviceCode.touched" errorMsg="Please inform your deviceCode">
                </app-field-error-display>
              </div>
              <!-- apiUrl -->
              <div class="form-group" *ngIf="data.vendorType == cashRegisterVendorTypeEnum.OMNISOFT|| data.vendorType == cashRegisterVendorTypeEnum.CASPOS||
                          data.vendorType == cashRegisterVendorTypeEnum.SMARTONE||data.vendorType == cashRegisterVendorTypeEnum.NBASOFT||data.vendorType == cashRegisterVendorTypeEnum.PAVO">
                <label class="custom-form-label" for="apiUrl">{{'common.apiUrl' | translate}}</label>
                <input type="text" #apiUrl="ngModel" name="apiUrl" [(ngModel)]="data.apiUrl" required class="form-control" [class.is-invalid]="apiUrl.invalid && apiUrl.touched" />

                <app-field-error-display [displayError]="apiUrl.invalid && apiUrl.touched" errorMsg="Please inform your apiUrl">
                </app-field-error-display>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group form-check form-switch">
                <input #status="ngModel" type="checkbox" class="form-check-input" name="status" id="status" [(ngModel)]="isActive" />
                <label class="form-check-label" for="status">{{'common.isActive' | translate}}</label>
              </div>
              <!-- Aktif mi -->
              <div class="form-group form-check form-switch" *ngIf="data.vendorType == cashRegisterVendorTypeEnum.ODEAL||data.vendorType == cashRegisterVendorTypeEnum.PAVO">
                <input #isSendConfigurationInput="ngModel" type="checkbox" class="form-check-input" name="isSendConfigurationInput" id="isSendConfigurationInput"
                  [(ngModel)]="data.isSendConfiguration" />
                <label class="form-check-label" for="isSendConfigurationInput">{{'cashRegister.isSendConfiguration' | translate}}</label>
              </div>

              <!-- Integration Expiry Date -->
              <div class="form-group" *ngIf="isHuginBekoOrPavo()">
                <label class="custom-form-label" for="integrationExpiryDate">{{'cashRegister.integrationExpiryDate' | translate}}</label>
                <p-calendar #integrationExpiryDate="ngModel" name="integrationExpiryDate" [(ngModel)]="data.integrationExpiryDate" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                  [dateFormat]="dateFormatEnum.DATE_PICKER_INPUT_FORMAT" [showTime]="false" [firstDayOfWeek]="'firstDayOfWeek'| translate">
                </p-calendar>
              </div>
            </div>
          </div>



        </div>
      </div>

      <div class="card mt-3" *ngIf="isHuginOrBeko()">
        <div class="card-header">
          <h6 class="mb-0">{{'cashRegister.vatRateDepartmentMapping' | translate}}</h6>
        </div>
        <div class="card-body">
          <div *ngFor="let mapping of vatRateDepartmentMappings; let i = index" class="row mb-2">
            <div class="col-md-4">
              <label class="custom-form-label">{{'cashRegister.vatRate' | translate}}</label>
            </div>
            <div class="col-md-3">
              <input type="text" class="form-control" [(ngModel)]="mapping.vatRate" [name]="'vatRate_' + i" placeholder="{{'cashRegister.vatRate' | translate}}" />
            </div>
            <div class="col-md-3">
              <input type="number" class="form-control" [(ngModel)]="mapping.departmentCode" [name]="'departmentCode_' + i" placeholder="{{'cashRegister.departmentCode' | translate}}" min="0" />
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-danger btn-sm" (click)="removeVatRateDepartmentMapping(i)">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
          <button type="button" class="btn btn-primary btn-sm" (click)="addVatRateDepartmentMapping()">
            <i class="fas fa-plus"></i> {{'button.add' | translate}}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">
    {{'button.close' | translate}}
  </button>

  <button type="button" [disabled]="createForm.form.invalid" class="btn btn-primary" (click)="save()">
    {{'button.save' | translate}}
  </button>
</div>